import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment.prod';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private http: HttpClient) {}

    public signIn(idNumber: string, password: string) {
        return this.http.post(`${environment.api_url}/auth/admin-signin`, {
            idNumber,
            password,
        });
    }

    public signUp(data: {
        email: string;
        password: string;
        confirmPassword: string;
        organization: string;
        organizationName: string;
    }) {
        return this.http.post(`${environment.api_url}/auth/register`, data);
    }

    public getUserAccount(userId: string) {
        return this.http.get(`${environment.api_url}/users/get-admin-user`);
    }

    public searchOrganizations(searchTerm: string, email: string, password: string) {
        const params = new HttpParams({
            fromObject: {
                searchTerm,
                email,
                password,
            },
        });
        return this.http.get(`${environment.api_url}/organizations/search-organizations`, { params: params });
    }

    public getOrganization(organizationId: string) {
        return this.http.get(`${environment.api_url}/organizations/${organizationId}`);
    }

    public getOrganizationAccount(organizationId: string) {
        return this.http.get(`${environment.api_url}/organizations/${organizationId}/account`);
    }

    public forgotPassword(email: string) {
        return this.http.post(`${environment.api_url}/user/profile/requestpasswordandsendlink`, { email });
    }
    validateUsername(username: string) {
        return this.http.post<{ isValid: boolean }>(`${environment.api_url}/auth/validate/username`, { username });
    }
}
